import { types } from "../types/types";

export const setPreviousSearchParams = (params) => ({
    type: types.SET_PREVIOUS_SEARCH_PARAMS,
    payload: params,
});

export const setCurrentSearchParams = (params) => ({
    type: types.SET_CURRENT_SEARCH_PARAMS,
    payload: params,
});

export const cleanSearchParams = () => ({
    type: types.CLEAN_SEARCH_PARAMS,
});

export const cleanSearchParamsNoModule = () => ({
    type: types.CLEAN_SEARCH_PARAMS_NO_MODULE,
});